import { modal, message } from 'iview'

export default {
  install (Vue) {
    Vue.prototype.$Modal = modal
    Vue.prototype.$Message = message
  }
}
